import React, { useEffect, useState, useRef, memo } from "react";
import { get, updateToken } from "../../../../helpers/api_helper";
import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";

const CandleChart = () => {
  const token = useSelector((state) => state.login.token);

  const [stocks, setStocks] = useState([]);
  const [selectedStock, setSelectedStock] = useState("");

  const container = useRef();

  useEffect(() => {
    const fetchStocks = async () => {
      try {
        const response = await get("/admin/stock-exchange");
        if (response?.success) {
          setStocks(response?.data?.items);
          if (response?.data?.items?.length > 0) {
            setSelectedStock(response?.data?.items[0]?.stock_name);
          }
        }
      } catch (error) {
        console.error("Error fetching stock data:", error);
      }
    };

    fetchStocks();
  }, []);

  useEffect(() => {
    if (token) {
      updateToken(token);
    }

    if (selectedStock) {
      container.current.innerHTML = "";

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = `
        {
          "autosize": true,
          "symbol": "${selectedStock}",
          "interval": "D",
          "timezone": "Etc/UTC",
          "theme": "light",
          "style": "1",
          "locale": "en",
          "allow_symbol_change": false,
          "calendar": false,
          "support_host": "https://www.tradingview.com"
        }`;
      container.current.appendChild(script);
    }
  }, [token, selectedStock]);

  return (
    <div style={{ height: "100vh" }}>
      <Form.Select
        className="small-select"
        value={selectedStock}
        onChange={(e) => setSelectedStock(e.target.value)}
        style={{ marginBottom: "10px", padding: "5px" }}
      >
        {stocks?.map((stock) => (
          <option key={stock._id} value={stock.ticker_name}>
            {stock.ticker_name}
          </option>
        ))}
      </Form.Select>
      <div
        className="tradingview-widget-container"
        ref={container}
        style={{ height: "90%", width: "100%" }}
      >
        <div
          className="tradingview-widget-container__widget"
          style={{ height: "100%", width: "100%" }}
        ></div>
      </div>
    </div>
  );
};

export default memo(CandleChart);
